'use client'

import { createContext, use } from 'react'
import type { FeatureFlagTypes } from './featureFlagTypes'

export const FeatureFlagsContext = createContext<Record<string, boolean>>({})

export default function useFeatureFlag(feature: FeatureFlagTypes) {
  const enabled = use(FeatureFlagsContext)[feature]
  return { enabled: Boolean(enabled), pending: false }
}
